import type { $ } from "../../../dom";
import { SelectInput, type SelectInputOptions } from "../base";

export type SimpleSelectInputOptions = Omit<
  SelectInputOptions<string | null>,
  "resetValue"
>;

export class SimpleSelectInput extends SelectInput<string | null> {
  constructor($root: $, options: SimpleSelectInputOptions = {}) {
    const { ...superOptions } = options;

    super($root, {
      resetValue: "",
      ...superOptions,
    });
  }

  get data(): string | null {
    return this.value ? this.$options.eq(`[value="${this.value}"]`).text : null;
  }
}
